import axios, {AxiosResponse} from 'axios'
// import {Response} from '../../../../../../_metronic/helpers'
import {Plan, PlanQueryResponse} from './_models'
import {getToken} from '../../../../auth'

//BASE_URL LINK
const API_URL = process.env.REACT_APP_API_URLS 

//ROLE API URL
const CREATE_PLAN_URL = `${API_URL}/plan/add`
const GET_PLAN_URL = `${API_URL}/plan/query`
const VIEW_PLAN_URL = `${API_URL}/plan/view`
const UPDATE_PLAN_URL = `${API_URL}/plan/update`
const DELETE_PLAN_URL = `${API_URL}/plan/delete`
const GET_PLANLIST_URL = `${API_URL}/plan/planfeatures-list`

//AuthVerify
var AuthVerify = getToken.call(this)

//Plan LIST
const getPlan = (query: string): Promise<PlanQueryResponse> => {
  return axios
    .post(`${GET_PLAN_URL}/?${query}`, getToken())
    .then((response: AxiosResponse<PlanQueryResponse>) => {
      return response.data
    })
}

//Plan ADD
const createPlan = (data: any): Promise<Plan | undefined> => {
  console.log("data", data);
  return axios.post(CREATE_PLAN_URL, data, getToken()).then((response: any) => response.data)
}

//Plan VEIW
const viewPlan = (id: any) => {
  return axios.get(`${VIEW_PLAN_URL}/${id}`, getToken()).then((response) => {
    return response.data
  })
}

//Plan UPDATE 
const updatePlan = (data: any, id: any) => {
  console.log('reqData=update-Plan', data)
  return axios.put(`${UPDATE_PLAN_URL}/${id}`, data, getToken()).then((response) => {
    console.log('updatemp-Plan', response.data)
    return response.data
  })
}

//Plan DELETE
const deletePlanById = (id: any) => {
  return axios.post(`${DELETE_PLAN_URL}/${id}`, AuthVerify).then((response) => {
    return response.data
  })
}

//GET ROLE
const getPlanFeatures = async () => {
  const res = await axios.get(`${GET_PLANLIST_URL}`, getToken())
  console.log('GET_PLANLIST_URLList=>', res)
  return res
}

export {getPlan, createPlan, viewPlan, updatePlan, deletePlanById, getPlanFeatures}
